export default __webpack_public_path__ + "static/media/doctor-1.279ca965.png";